import React, { ReactNode } from 'react';
import styled from 'styled-components';

import { IUEvent, IUInvitee } from '../../lib/event';
import { ActionStatusPill, EmptyTable, StatusPill, TableCell, TableContainer, TableHeader, TableRow } from './InviteTable';

import { DeviceQueries } from 'Common/src/components/styled';

import { TAppElkCohostRequestStatus } from 'TProtocol/prototypes/events/messages';
import { formatCohostStatus } from '../../util/attendee';
import PencilAlt from '../icons/PencilAlt';
import DeleteIcon from '../icons/DeleteIcon';
import { useUserContext } from '../../contexts/UserContext';

interface Props {
  event: IUEvent;
  cohosts: IUInvitee[];
  onDelete: (invite: IUInvitee) => void;
  onEdit: (inviteId: string) => void;
}

const CohostTable = ({ event, cohosts, onEdit, onDelete }: Props) => {
  const userContext = useUserContext();

  return <TableContainer>
    <Table>
      <TableRow>
        <TableHeader/>
        <TableHeader>Name</TableHeader>
        <TableHeader/>
      </TableRow>
      {
        cohosts.length > 0 && cohosts.map((cohost, index) => {
          const isMe = cohost.userId === userContext.id;
          const isOrganizer = cohost.userId === event.organizerUuid;

          return <TableRow key={cohost.inviteeId} $hasFooter={index === cohosts.length - 1}>
            <TableCell data-first="true">
              <StatusPill>
                {formatCohostStatus(cohost)}
              </StatusPill>
            </TableCell>
            <TableCell>{cohost.name || <>&mdash;</>}</TableCell>
            <TableCell>
              {
                <IconsContainer>
                  {!isMe && !isOrganizer ? <ActionIconContainer onClick={() => onDelete(cohost)}>
                    <DeleteIcon opacity={0.5}/>
                  </ActionIconContainer> : null}
                </IconsContainer>
              }
            </TableCell>
          </TableRow>;
        })
      }
    </Table>
    {
      cohosts.length === 1 && <EmptyTable>
        <div>There are no cohosts for this party.</div>
      </EmptyTable>
    }
  </TableContainer>;
};

const Table = styled.div`
  display: grid;
  grid-template-columns: max-content 1fr max-content;
  max-height: 100%;
  margin-top: 20px;
`;

const IconsContainer = styled.span`
  display: flex;
  gap: 8px;
  align-items: center;
  width: 100%;
`;

const ActionIconContainer = styled.span`
  cursor: pointer;
  width: 100%;
  text-align: right;
`;

export default CohostTable;
